import { useQuery } from '@tanstack/react-query';
import { getPipelineBuildSourceQuery } from '../apis';
import queryKeys from '../constants/queryKeys';

// GET /api/pipelines/{id}/build-source -> PipelineBuildSourceDto | 404. Read-only build
// coordinates (Branch / Dockerfile / Repo / Tag) the pipeline's NEXT run will use, resolved
// server-side from the latest DockerImageMetaData for the ImageName. Exposed under
// PIPELINE_READ so the detail page needs no REPOSITORY_READ. Never retry a 404 (the pipeline
// is gone — the page's own useGetDetailPipeline already drives the "no longer available" state).
const useGetPipelineBuildSource = id => {
	return useQuery({
		queryKey: queryKeys.getBuildSource(id),
		queryFn: () => getPipelineBuildSourceQuery(id),
		enabled: !!id,
		retry: (failureCount, error) => error?.response?.status !== 404 && failureCount < 1
	});
};

export default useGetPipelineBuildSource;
